import styled from '@emotion/styled';
import { Button } from 'src/ui/components/button/common/Button';

export const MiniCasinoBtn = styled(Button, { label: 'MiniCasinoBtn' })`
    width: 100%;
`;
